import { KeyValue } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IColumn, IDataTableActionComponent } from '@pacifico/interfaces/components.interface';
import { Util } from '@pacifico/utils/util';

@Component({
	selector: 'app-table-action',
	templateUrl: './table-action.component.html',
	styleUrls: ['./table-action.component.scss']
})
export class TableActionComponent {
	@Input() dataTable!: IDataTableActionComponent;
	@Output() clickShowButton = new EventEmitter();
	@Output() clickSendTitle = new EventEmitter();
	containDolar(item: unknown): boolean {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		const result = Object.values(item).find((item) => item === 'DÓLARES');
		return result !== undefined;
	}

	getConfig(indexColumn: number): IColumn | null {
		if (!this.dataTable.configColumn) {
			return null;
		}
		const config = this.dataTable.configColumn.find((config) => config.indexColumn === indexColumn);

		if (config == undefined) {
			return null;
		}

		return config;
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	originalOrder = (_a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
		return 0;
	};

	isNumber(value: unknown): boolean {
		return Util.isNumber(value as string);
	}

	getIterator(isSoles: boolean): number[] {
		const start = isSoles
			? this.dataTable.subtotalSoles!.indexColumnStart
			: this.dataTable.subtotalDolares!.indexColumnStart;
		return new Array<number>(start + 1);
	}

	clickItem(item: unknown): void {
		this.clickSendTitle.emit(this.dataTable.title);
		this.clickShowButton.emit(item);
	}

	getNumberCard(item: unknown): boolean {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		const result = Object.values(item).find((numeroTarjeta) => numeroTarjeta === '');
		return !(result !== undefined);
	}

	isFieldCard(item: unknown): boolean {
		return item === 'numeroTarjeta';
	}

	isFieldAccountNumber(item: unknown): boolean {
		return item === 'nrCuenta';
	}

	isNegative(value: string): boolean {
		return Util.isNegative(value);
	}

	isCurrency(value: string): boolean {
		return value === 'PEN' || value === 'US$';
	}

	transformCurrency(value: string): string {
		return value === 'PEN' ? 'SOLES' : 'DÓLARES';
	}
}
